export default {
  methods: {
    getAllergyIcons(allergenIds, classIds) {
      let allergenIcons = [];
      let classIcons = [];

      if (allergenIds) {
        let allergens = this.storeConfig?.allergens.filter(allergen => allergenIds.includes(allergen.id));
        if (allergens) {
          allergenIcons = allergens?.map(allergen => {
            return {
              name: allergen.name,
              icon_url: allergen.icon_url,
              display: allergen.name.split(' ').map(word => word[0]).join('')
            };
          });
        }
      }
      if (classIds) {
        let itemClasses = this.storeConfig?.item_classes.filter(itemClass => classIds.includes(itemClass.id));
        if (itemClasses) {
          classIcons = itemClasses.map(itemClass => {
            return {
              name: itemClass.name,
              icon_url: itemClass.icon_url,
              display: itemClass.name.split(' ').map(word => word[0]).join('')
            };
          });
        }
      }
      return [...allergenIcons, ...classIcons];
    },
    getAllergyIconsFilter(allergenIds) {
      let allergens = [];
      if (this.storeConfig) {
        if (allergenIds && allergenIds.length > 0 && this.storeConfig?.allergens) {
          allergens = this.storeConfig?.allergens.filter((allergen) => allergenIds.includes(allergen.id));
        }
      }
      let icons = allergens?.map((allergen) => {
        return {
          id: allergen.id,
          name: allergen.name,
          icon_url: allergen.icon_url,
          display: allergen.name.split(' ').map((word) => word[0]).join('')
        }
      });
      return icons;
    },
    //filter item class
    getClassIconsFilter(itemClassIds) {
      let classes = [];
      if (this.storeConfig) {
        if (itemClassIds && itemClassIds.length > 0 && this.storeConfig?.item_classes) {
          classes = this.storeConfig?.item_classes.filter((itemClass) => itemClassIds.includes(itemClass.id));
        }
      }
      let icons = classes?.map((itemClass) => {
        return {
          id: itemClass.id,
          name: itemClass.name,
          icon_url: itemClass.icon_url,
          display: itemClass.name.split(' ').map((word) => word[0]).join('')
        }
      });
      return icons;
    }
  },
}
